export default {
  widgets: {
    cancelApplicationRequestApprovalPanel: {
      title: "Arizangiz ko'rib chiqilmoqda",
      body: "Iltimos, ko'rib chiqish tugashini kuting.",
    },
  },
};
